import { Grid } from '@material-ui/core'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { GridItem } from '../../../../shared/grid-item'
import { MainPageImpactMetricCard } from '../main-page-impact-metric-card'
import { MainPageSectionHeader } from '../main-page-section-header'
import { useMainPageImpactMetricsSectionStyles } from './main-page-impact-metrics-section.styles'

const METRIC_IMAGES = [
  'recycled.jpg',
  'children.jpg',
  'giving.jpg',
] as const

function metricImageSrc(file: string): string {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '')
  return `${base}/images/impact-metrics/${file}`
}

type ImpactMetricItem = {
  value: string
  label: string
}

export const MainPageImpactMetricsSection: React.FC = () => {
  const classes = useMainPageImpactMetricsSectionStyles()
  const { t, i18n } = useTranslation()

  const items = useMemo((): ImpactMetricItem[] => {
    const raw = t('mainPage.impactMetrics.items', { returnObjects: true })
    return Array.isArray(raw) ? (raw as ImpactMetricItem[]) : []
  }, [t, i18n.language])

  return (
    <section
      className={classes.root}
      aria-labelledby="impact-metrics-heading"
    >
      <div className={classes.inner}>
        <MainPageSectionHeader
          titleId="impact-metrics-heading"
          title={t('mainPage.impactMetrics.title')}
          subtitle={t('mainPage.impactMetrics.subtitle')}
        />
        <Grid container spacing={3}>
          {items.map((item, index) => {
            const imageFile = METRIC_IMAGES[index]
            if (!imageFile) return null
            return (
              <GridItem key={imageFile} xs={12} sm={4}>
                <MainPageImpactMetricCard
                  value={item.value}
                  label={item.label}
                  imageSrc={metricImageSrc(imageFile)}
                />
              </GridItem>
            )
          })}
        </Grid>
      </div>
    </section>
  )
}
